/** @jsx jsx */
import React from 'react';
import { css, jsx, styled } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVGNavRefresh from './assets/roadmap-app-skeleton-nav-refresh.tpl.svg';
import imgSVGNavRefreshNoHeader from './assets/roadmap-app-skeleton-nav-refresh-no-header.svg';

const customCssStyles = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		borderRightWidth: 0,
	},
});

export const RoadmapSkeleton = (): JSX.Element => (
	<Wrapper>
		<AppSkeletonImage src={imgSVGNavRefresh} css={customCssStyles} />
	</Wrapper>
);

export const RoadmapSkeletonNoHeader = (): JSX.Element => (
	<div css={fullBleedWrapperStyles}>
		<AppSkeletonImage
			src={imgSVGNavRefreshNoHeader}
			hideBorder
			containerStyles={fullBleedContainerStyles}
			css={fullBleedMediaStyles}
		/>
	</div>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Wrapper = styled.div({
	display: 'contents',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'>div > img, > div > object': {
		borderLeftWidth: '24px',
		borderRightWidth: '24px',
	},
});

const fullBleedWrapperStyles = css({
	display: 'block',
	width: '100%',
	height: '100%',
	// Ensure the AppSkeletonImage wrapper stretches when this component is rendered as a flex item.
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'> div': {
		width: '100%',
		height: '100%',
	},
	// Ensure replaced image/object elements do not fall back to intrinsic 300px width.
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'> div > img, > div > object': {
		display: 'block',
		width: '100%',
		height: '100%',
		maxWidth: '100%',
		objectFit: 'contain',
		objectPosition: 'top left',
	},
});

const fullBleedContainerStyles = {
	width: '100%',
	height: '100%',
};

const fullBleedMediaStyles = css({
	display: 'block',
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	objectPosition: 'top left',
});
